var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep432(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_923_1943)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.7266,
    r: 16,
    fill: "#F3FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.364 20.552H18.876V23H16.892V20.552H11.804V19.048L16.94 11.544H18.876V18.904H20.364V20.552ZM16.892 16.344C16.892 16.12 16.892 15.8907 16.892 15.656C16.9027 15.4107 16.9133 15.1707 16.924 14.936C16.9347 14.7013 16.9453 14.488 16.956 14.296C16.9667 14.104 16.9773 13.9547 16.988 13.848H16.924C16.828 14.0507 16.7213 14.264 16.604 14.488C16.4973 14.7013 16.3747 14.904 16.236 15.096L13.644 18.904H16.892V16.344Z",
    fill: "#1778E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_923_1943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.726562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep432);
export default __webpack_public_path__ + "static/media/step-4-32.51c8f2a3.svg";
export { ForwardRef as ReactComponent };